import { Component, Inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { NotificationsService } from 'angular2-notifications';
import { ReportService } from "../../services/report.service";
import { TransactionService } from '../../services/transaction.service';
import { UserService } from '../../services/user.service';

const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}

@Component({
    selector: 'app-sent-receive-inr',
    templateUrl: './sent-receive-inr.component.html',
    styleUrls: ['./sent-receive-inr.component.css']
})
export class SentReceiveINRDialog {
    sentReceiveINRForm: FormGroup;
    element: any;
    maxAmount: any;
    price: any;
    constructor(
        public dialogRef: MatDialogRef<SentReceiveINRDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public fb: FormBuilder,
        public userService: UserService,
        private reportService: ReportService,
        public notifSer: NotificationsService,
        public service: TransactionService
    ) { }

    async ngOnInit() {
        this.element = this.data
        this.initForm();
        this.sentReceiveINRForm.get('type').disable();
        this.sentReceiveINRForm.get('currency').disable();
    }

    initForm() {
        this.price = this.element.currency === 'INR' ? 1 : '';

        this.sentReceiveINRForm = this.fb.group({
            amount: ['', [Validators.required, this.amountValidator.bind(this)]],
            price: [{ value: this.price, disabled: this.element.currency === 'INR' }],
            date: [new Date(), Validators.required],
            type: [this.element.type, Validators.required],
            currency: [this.element.currency, Validators.required],
            transaction_ref: ['', Validators.required],
            note: ['', Validators.required],
        });

        // Automatically calculate amount when price changes
        this.sentReceiveINRForm.get('price').valueChanges.subscribe(priceValue => {
            const base = this.element.amount;
            if (priceValue && base > 0) {
                const calculatedAmount = priceValue / base;
                this.sentReceiveINRForm.get('amount').setValue(calculatedAmount.toFixed(2), { emitEvent: false });
            }
        });
    }

    amountValidator(control: AbstractControl): { [key: string]: any } | null {
        const enteredAmount = Number(control.value);
        const maxAmount = Math.abs(Number(this.element.amount));
        this.maxAmount = maxAmount;
        if (enteredAmount <= 0) {
            return { negativeAmount: true };
        }
        if (enteredAmount && maxAmount && Math.abs(enteredAmount) > maxAmount) {
            return { amountExceeded: true };
        }

        return null;
    }


    saveSentReceive() {
        const { notif } = defaults;
        try {
            console.log(this.sentReceiveINRForm.value, 'element==')
            if (this.sentReceiveINRForm.valid) {
                this.userService.csrf().subscribe(success => {
                    this.sentReceiveINRForm.value['_csrf'] = success['_csrf'];
                    this.sentReceiveINRForm.value['transaction_id'] = this.element._id;
                    this.sentReceiveINRForm.value['type'] = this.element.type;
                    this.sentReceiveINRForm.value['currency'] = this.element.currency;
                    this.sentReceiveINRForm.value['price'] = this.price || this.sentReceiveINRForm.value['price'];
                    this.service.saveSentReceiveINR(this.sentReceiveINRForm.value).subscribe((response) => {
                        if (response) {
                            this.notifSer.success('Success', response.message, notif)

                            this.dialogRef.close({ success: true, data: response.message });

                        } else this.notifSer.error('Error', response.message, notif);
                    }, (error) => {
                        this.notifSer.error(
                            'Error',
                            error.error.message,
                            {
                                timeOut: 3000,
                                showProgressBar: true,
                                pauseOnHover: false,
                                clickToClose: true,
                                maxLength: 50
                            }
                        )
                    })
                })
            } else {
                this.notifSer.error('Error', 'Please select user', notif)
            }
        } catch (error) {

        }
    }
}


// WEBPACK FOOTER //
// ./src/app/client-transactions/sent-receive-inr/sent-receive-inr.component.ts